import { iterLines } from './lexer.js';
/** Matches a 16-hex-char SA mask token. */
const SA_MASK_RE = /^[0-9A-Fa-f]{16}$/;
/** Matches a 10-hex-char FA mask token. */
const FA_MASK_RE = /^[0-9A-Fa-f]{10}$/;
export function parseZst(content) {
    const header = {};
    const records = [];
    const unparsed = [];
    for (const line of iterLines(content)) {
        const raw = line.trimmed;
        const tr = raw.trim();
        if (tr === '')
            continue;
        // Header records first.
        if (tr.startsWith(';Tabelle:')) {
            // ;Tabelle: <name>   Index: <idx>  vom: <date>  NAEL: <doc>
            const m = tr.match(/;Tabelle:\s*(\S+)\s+Index:\s*(\S+)\s+vom:\s*(\S+)\s+NAEL:\s*(\S+)/);
            if (m) {
                header.tabelle = m[1];
                header.index = m[2];
                header.vom = m[3];
                header.nael = m[4];
            }
            continue;
        }
        if (/^I\s+\S+$/.test(tr)) {
            header.index ??= tr.split(/\s+/)[1];
            continue;
        }
        if (/^U\s+\d{14}$/.test(tr)) {
            header.timestamp = tr.split(/\s+/)[1];
            continue;
        }
        if (/^V\s+\S+/.test(tr)) {
            header.filename = tr.split(/\s+/)[1];
            continue;
        }
        // Decoration-only rows (e.g. `;************`).
        if (/^;\s*\*+\s*$/.test(tr) || /^;\s*\*/.test(tr.split(/[^*]/)[0] ?? ''))
            continue;
        // Free-text comment rows that don't contain a SA-mask token.
        if (!tr.startsWith(';') && !/^[A-Z]/.test(tr))
            continue;
        // A data row starts with `;`, then has SA-code or empty SA-code slot, then masks.
        // Strategy: find the first 16-hex-char token in the line; everything left of it is
        // (SA-code, optional marker); everything right is (FA-mask, FSW, ...).
        let payload = tr.startsWith(';H') ? tr.slice(2) : tr.startsWith(';') ? tr.slice(1) : tr;
        payload = payload.trimStart();
        const tokens = payload.split(/\s+/).filter((t) => t.length > 0);
        if (tokens.length < 2)
            continue;
        const maskIdx = tokens.findIndex((t) => SA_MASK_RE.test(t));
        if (maskIdx === -1) {
            // No SA-mask token on this line — treat as comment / pre-amble.
            continue;
        }
        const left = tokens.slice(0, maskIdx);
        const saMask = tokens[maskIdx];
        const right = tokens.slice(maskIdx + 1);
        const faMask = right[0] && FA_MASK_RE.test(right[0]) ? right[0] : '';
        const fsw = (faMask ? right[1] : right[0]) ?? '';
        const kind = tr.startsWith(';H') ? 'hidden' : 'regular';
        records.push({
            kind,
            saCode: left[0] ?? '',
            marker: left.slice(1).join(' '),
            saMask,
            faMask,
            fsw,
            comment: line.comment,
            lineNo: line.lineNo,
        });
    }
    if (records.length === 0 && unparsed.length === 0) {
        // Surface the case of "we read the file but found nothing recognisable" as a soft warning.
    }
    return { header, records, unparsed };
}
//# sourceMappingURL=zst.js.map